module.exports = App.StaticPagesController = Em.Controller.extend
  env:     Em.inject.service('environment')